import { createAction } from '@reduxjs/toolkit';
import { ACKNOWLEDGE_LEAK_DETECTOR, GET_LEAK_DETECTORS } from '../constants';

export const acknowledgeLeak = createAction(ACKNOWLEDGE_LEAK_DETECTOR);
export const searchLeakDetectors = createAction(GET_LEAK_DETECTORS);

export default {
  searchLeakDetectors
};
